import type { ReactNode } from "react";
import { FREE_PERMITTED_LIMIT_TIME_FRAME_DAY, FREE_PERMITTED_LIMIT, FORMATTED_MONTHLY_FEE } from '../../components/common/constants/constants';

export type FaqItem = {
  id: string;
  q: string;
  a: ReactNode;
};

export const faqItems: FaqItem[] = [
  {
    id: "what-is-mrjoe",
    q: "What is MrJoe.Pro?",
    a: `MrJoe.Pro is straightforward software made for guys like you—contractors, handymen, and home improvement crews—who are out on job sites all day. It takes the headache out of paperwork so you can get estimates and invoices done fast, keep track of customers and projects, follow up on payments, and message clients without jumping between apps. Everything lives in one simple place, no complicated setup, just tools that actually help you finish the day quicker and get paid sooner`
  },
  {
    id: "how-much-mrjoe",
    q: "How much does it cost to use MrJoe.Pro?",
    a: (
      <>
        <p>
          You can jump in for free—no card needed. The Free Plan gives you up to {FREE_PERMITTED_LIMIT} new projects, estimates, or invoices every {FREE_PERMITTED_LIMIT_TIME_FRAME_DAY} days—plenty to try it out or handle small weeks.
        </p>
        <br></br>
        <p>
          When you're ready for unlimited everything (no caps, all features), it's just {FORMATTED_MONTHLY_FEE}/month.
          Pay for one month or stock up on a few—no contracts, cancel anytime, and zero hidden fees. Simple as that.
        </p>
      </>
    ),
  },

  {
    id: "mrjoe-work-process",
    q: "How do I get started with MrJoe.Pro to unlock its full power?",
    a: (
      <>
        <h4 className="font-semibold mb-3">Simple Workflow to Get Up and Running</h4>
        <ul className="list-disc space-y-1 pl-5">
          <li>
            Create your company and your online account (free, no card needed).
          </li>
          <li>
            Sign in your account, and add a customer with contact details.
          </li>
          <li>
            Create a new project for that customer.
          </li>
          <li>
            Generate an estimate instantly using our industry-first AI engine—or build it manually.
          </li>
          <li>
            Turn the approved estimate into an invoice and track payments in real time.
          </li>
          <li>
            Keep clients updated: send estimates, invoices, and payment reminders via email or SMS directly from the app.
          </li>
          <li>
            Upload before & after photos to show new clients what you can do—in just two clicks.
          </li>
          <li>
            Need crew tracking? Set up a job site and share timecard links so employees can clock in/out effortlessly.
          </li>
        </ul>
      </>
    )
  },


  {
    id: "ai-smart-estimates",
    q: "What is good about the AI powered estimates?",
    a: `No more hours guessing prices or checking material costs. Just tell it what the job needs, and it builds a solid, professional estimate using real current rates for materials and labor. We built our own engine behind it, so the numbers make sense for actual job sites—not some generic guess.`
  },

  {
    id: "how-secure-data",
    q: "How secure are my data and payments?",
    a: "MrJoe.Pro prioritizes your peace of mind with PCI DSS compliance and Stripe's battle-tested payment processing. Every transaction and piece of data is end-to-end encrypted—meaning we never store your credit card details, so you stay protected without the worry."
  },
  {
    id: "data-privacy",
    q: "Can other MrJoe.Pro users or companies see my customer data?",
    a: "No—your data is completely private and secure. Each account is tied exclusively to your company, so only you can access your customers, projects, and information. No one else on MrJoe.Pro can view or retrieve it."
  },

  {
    id: "can-I-export-PDF",
    q: "Can I export an estimate or invoice as PDF and send it to my customers?",
    a: "Yes, all documents can be downloaded as PDF and sent directly to customers by email or SMS text message."
  },
  {
    id: "mrjoe-features-services",
    q: "What features-services MrJoe.Pro offers?",
    a: (
      <>

        <ul className="list-disc space-y-1 pl-5">
          <li>
            <span className="font-semibold">AI-Powered Estimates</span>:
            Industry-first tool that builds solid, market-right bids in seconds—just describe the job and it
            pulls current material and labor prices. You can send them to customers right away or tweak them as needed.
          </li>
          <li>
            <span className="font-semibold">Estimates & Invoices: </span>: Create them fast from your projects, then view or send professional PDFs right away.

          </li>
          <li>

            <span className="font-semibold">Project/Customer Management: </span>:
            Keep track of jobs, timelines, tasks, and every customer's history in one spot.
          </li>
          <li>
            <span className="font-semibold">Payment Tracking: </span>:
            Record what customers pay, send payment receipts or reminders, and see at a glance who's paid up and who's overdue—no digging through papers or emails
          </li>
          <li>
            <span className="font-semibold">Customer Communication</span>:
            Send estimates, invoices, and payment reminders by email or text straight from the app—everything stays logged so nothing slips through.

          </li>
          <li>
            <span className="font-semibold">Before" and "after" project photos: </span>
            Upload job photos easily, line them up side-by-side, and show clients exactly what you can do. Great for winning the next bid.
          </li>
          <li>
            <span className="font-semibold">Digital Time Cards: </span>
            Let your crew clock in and out on their phones. Hours roll up automatically for quick payroll and job costing reports.
          </li>
        </ul>
      </>
    )
  },




  {
    id: "addiontal-account",
    q: "After creating my company and my own online account, how can I add more team members to MrJoe.Pro?",
    a: "Team access is invitation-only for security and simplicity. Just log in to your account, go to the Account section, and click \"Send Invite.\" Enter their email or phone number—we'll instantly send a secure link. They click it, sign up, and join your company automatically. No extra setup needed!"
  },

];
